import React from "react";
import {EClubInfoPage} from "../../../../models";
import {ContentBasedClubPage} from "../../contentBased/ContentBasedClubPage";

export function ClubStadiumHistory() {
	return (<ContentBasedClubPage page={EClubInfoPage.STADIUM_HISTORY}/>)
}
